import {
  Download, Tag, ShieldCheck, Ban, Trash2, ChevronDown, Building2, Percent,
} from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ICONS = { export: Download, status: Tag, verified: ShieldCheck, suspend: Ban, delete: Trash2, assign: Building2, discount: Percent };

export function BulkBar({ count, role, actions, statusOptions = [], assignOptions = [], onAction, onClear }) {
  const { t } = useI18n();
  const visible = actions.filter((a) => !a.roles || a.roles.includes(role));
  return (
    <div className="flex items-center gap-2 flex-wrap bg-blue-900 text-white rounded-xl px-4 py-2.5" data-testid="bulk-bar">
      <span className="text-sm font-medium" data-testid="bulk-count">{count} {t("common.selected")}</span>
      <div className="h-5 w-px bg-white/20 mx-1" />
      {visible.map((a) => {
        const Icon = ICONS[a.kind] || Tag;
        if (a.kind === "status") {
          return (
            <DropdownMenu key={a.key}>
              <DropdownMenuTrigger asChild>
                <Button size="sm" variant="secondary" className="h-8" data-testid={`bulk-${a.kind}`}><Icon size={14} className="mr-1" /> {t(a.label)} <ChevronDown size={13} className="ml-1" /></Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {statusOptions.map((s) => (
                  <DropdownMenuItem key={s.value} onClick={() => onAction("set_status", s.value)} data-testid={`bulk-status-${s.value}`}>{t(s.label)}</DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          );
        }
        if (a.kind === "assign") {
          return (
            <DropdownMenu key={a.key}>
              <DropdownMenuTrigger asChild>
                <Button size="sm" variant="secondary" className="h-8" data-testid={`bulk-${a.kind}`}><Icon size={14} className="mr-1" /> {t(a.label)} <ChevronDown size={13} className="ml-1" /></Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="max-h-64 overflow-y-auto">
                {assignOptions.length === 0 && <DropdownMenuItem disabled>—</DropdownMenuItem>}
                {assignOptions.map((o) => (
                  <DropdownMenuItem key={o.value} onClick={() => onAction("assign_partner", o.value)}>{o.label}</DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          );
        }
        return (
          <Button key={a.key} size="sm" variant={a.kind === "delete" ? "destructive" : "secondary"} className="h-8"
            data-testid={`bulk-${a.kind}`}
            onClick={() => {
              if (a.kind === "discount") {
                const v = window.prompt(t("bulk.discount") + " %");
                if (v !== null && v !== "") onAction("set_discount", Number(v));
                return;
              }
              onAction(a.action, a.value);
            }}>
            <Icon size={14} className="mr-1" /> {t(a.label)}
          </Button>
        );
      })}
      <div className="ml-auto">
        <Button size="sm" variant="ghost" className="h-8 text-white hover:bg-white/10" onClick={onClear} data-testid="bulk-clear">{t("common.cancelSelection")}</Button>
      </div>
    </div>
  );
}
